import { useMutation } from "react-query";
import incidentService from "../../services/incidentService";

const useAddIncident = () => useMutation(incidentService.addIncident);

export default useAddIncident;
